<div class="py-1" role="none">
    <ng-container *ngIf="['driver','vehicle'].includes(source)">
        <a href="javascript:void(0)" (click)="edit.emit()"
            class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
            role="menuitem" tabindex="-1" id="menu-item-0">
               <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                stroke-width="1.5" stroke="currentColor" class="mr-3 h-5 w-5 text-main-primary">
                <path stroke-linecap="round" stroke-linejoin="round"
                 d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
               </svg>
            Edit
        </a>
        <ng-container *ngIf="entity.isActive">
            <a href="javascript:void(0)" (click)="sync.emit()" 
                class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
                role="menuitem" tabindex="-1" id="menu-item-0">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                    class="mr-3 h-5 w-5 text-main-primary" [ngClass]="{'animate-spin': loading && loading === entity.id}">
                    <path stroke-linecap="round" stroke-linejoin="round"
                        d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
                </svg>
                Sync
            </a>
        </ng-container>
        
        <a href="javascript:void(0)" (click)="logs.emit()"
            class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
            role="menuitem" tabindex="-1" id="menu-item-0">
            <svg xmlns="http://www.w3.org/2000/svg" class="mr-3 h-5 w-5 text-main-primary"
                viewBox="0 0 48 48"><!-- Icon from IconPark Outline by ByteDance - https://github.com/bytedance/IconPark/blob/master/LICENSE -->
                <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="4">
                    <path stroke-linejoin="round" d="M24 44H10a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h28a2 2 0 0 1 2 2v18m-4.5 20V31" />
                    <path stroke-linejoin="round" d="m31 34.5l1.5-1.5l3-3l3 3l1.5 1.5" />
                    <path d="M16 16h16m-16 8h8" />
                </g>
            </svg>
            Logs
        </a>
        <a *ngIf="source === 'vehicle'" href="javascript:void(0)" (click)="downloadInspectionForm.emit()"
            class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
            role="menuitem" tabindex="-1" id="menu-item-0">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                class="mr-3 h-5 w-5 text-main-primary">
                <path stroke-linecap="round" stroke-linejoin="round"
                    d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3" />
            </svg>
            Inspection Form
        </a>
        <a href="javascript:void(0)" (click)="raiseTicket.emit()"
            class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
            role="menuitem" tabindex="-1">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" class="mr-3 h-5 w-5 text-main-primary">
                <path stroke-linecap="round" stroke-linejoin="round"
                    d="M16.5 6v.75m0 3v.75m0 3v.75m0 3V18m-9-5.25h5.25M7.5 15h3M3.375 5.25c-.621 0-1.125.504-1.125 1.125v3.026a2.999 2.999 0 0 1 0 5.198v3.026c0 .621.504 1.125 1.125 1.125h17.25c.621 0 1.125-.504 1.125-1.125v-3.026a2.999 2.999 0 0 1 0-5.198V6.375c0-.621-.504-1.125-1.125-1.125H3.375Z" />
            </svg>
            Raise ticket
        </a>
    </ng-container>
      <ng-container *ngIf="source==='attachment'">
        <a href="javascript:void(0)" (click)="edit.emit()"
            class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
            role="menuitem" tabindex="-1" id="menu-item-0">
               <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                stroke-width="1.5" stroke="currentColor" class="mr-3 h-5 w-5 text-main-primary">
                <path stroke-linecap="round" stroke-linejoin="round"
                 d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
               </svg>
            Edit
        </a>
        <a href="javascript:void(0)" (click)="delete.emit()"
            class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
            role="menuitem" tabindex="-1" id="menu-item-0">
            <svg xmlns="http://www.w3.org/2000/svg" class="mr-3 h-5 w-5 text-main-primary"
                viewBox="0 0 24 24"><!-- Icon from Material Symbols by Google - https://github.com/google/material-design-icons/blob/master/LICENSE -->
                <path fill="currentColor"
                    d="M7 21q-.825 0-1.412-.587T5 19V6H4V4h5V3h6v1h5v2h-1v13q0 .825-.587 1.413T17 21zM17 6H7v13h10zM9 17h2V8H9zm4 0h2V8h-2zM7 6v13z" />
            </svg>
            Delete
        </a>
        <a href="javascript:void(0)" (click)="logs.emit()"
            class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
            role="menuitem" tabindex="-1" id="menu-item-0">
            <svg xmlns="http://www.w3.org/2000/svg" class="mr-3 h-5 w-5 text-main-primary"
                viewBox="0 0 48 48"><!-- Icon from IconPark Outline by ByteDance - https://github.com/bytedance/IconPark/blob/master/LICENSE -->
                <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="4">
                    <path stroke-linejoin="round" d="M24 44H10a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h28a2 2 0 0 1 2 2v18m-4.5 20V31" />
                    <path stroke-linejoin="round" d="m31 34.5l1.5-1.5l3-3l3 3l1.5 1.5" />
                    <path d="M16 16h16m-16 8h8" />
                </g>
            </svg>
            Logs
        </a>
    </ng-container>
       
</div>


